import React from "react";
import { Navigate } from "react-router-dom";

export default function ProtectedRoute({ role, children }) {
  const token = localStorage.getItem(
    role === "admin" ? "cct_admin_token" : "cct_recruiter_token"
  );
  if (!token) {
    return (
      <Navigate
        to={role === "admin" ? "/admin-login" : "/recruiter/login"}
        replace
      />
    );
  }
  return children;
}
